// memo mode: normal, creating, moving
const MODE_NORMAL = 1;
const MODE_CREATING = 2;
const MODE_MOVING = 3;

// memo max length;
const MEMO_MAXLENGTH = 8;

export { MODE_NORMAL, MODE_CREATING, MODE_MOVING, MEMO_MAXLENGTH };
